<template>
  <v-img :src="backgroundImage" min-height="100%">
    <v-container class="" style="max-width: 500px">
      <v-row>
        <v-col cols="4" class="pa-2">
          <v-card
            class="pa-3 rounded-xl"
            :to="{ name: 'SessionList' }"
            color="transparent"
            max-width="150px"
            elevation="0"
          >
            <v-img src="@/assets/icons/Agenda.png" contain></v-img>
          </v-card>
        </v-col>
        <v-col cols="4" class="pa-2">
          <v-card
            class="pa-3 rounded-xl"
            :to="{ name: 'PersonTypeSelect' }"
            color="transparent"
            max-width="150px"
            elevation="0"
          >
            <v-img src="@/assets/icons/Faculty.png" contain></v-img>
          </v-card>
        </v-col>
        <v-col cols="4" class="pa-2">
          <v-card
            class="pa-3 rounded-xl"
            :to="{ name: 'Information' }"
            color="transparent"
            max-width="150px"
            elevation="0"
          >
            <v-img src="@/assets/icons/Information.png" contain></v-img>
          </v-card>
        </v-col>
        <v-col cols="4" class="pa-2">
          <v-card
            class="pa-3 rounded-xl"
            :to="{ name: 'UnitList' }"
            color="transparent"
            max-width="150px"
            elevation="0"
          >
            <v-img src="@/assets/icons/What's On.png" contain></v-img>
          </v-card>
        </v-col>
        <v-col cols="4" class="pa-2">
          <v-card
            class="pa-3 rounded-xl"
            :to="{ name: 'MySchedule' }"
            color="transparent"
            max-width="150px"
            elevation="0"
          >
            <v-img src="@/assets/icons/My Schedule.png" contain></v-img>
          </v-card>
        </v-col>
        <v-col cols="4" class="pa-2">
          <v-card
            class="pa-3 rounded-xl"
            :to="{ name: 'SponsorList' }"
            color="transparent"
            max-width="150px"
            elevation="0"
          >
            <v-img src="@/assets/icons/Sponsorship.png" contain></v-img>
          </v-card>
        </v-col>
        <v-col cols="4" class="pa-2">
          <v-card
            class="pa-2"
            color="transparent"
            href="https://www.tsvs.org/teach.php"
            max-width="150px"
            elevation="0"
          >
            <v-img src="@/assets/icons/Tw-DRG.png" contain></v-img>
          </v-card>
        </v-col>
        <v-col cols="4" class="pa-2">
          <v-card
            class="pa-3 rounded-xl"
            color="transparent"
            href="https://www.tsvs.org/news.php"
            max-width="150px"
            elevation="0"
          >
            <v-img src="@/assets/icons/News.png" contain></v-img>
          </v-card>
        </v-col>
        <!-- <v-col cols="4" class="pa-2">
        <v-card class="pa-3 rounded-xl"  color="transparent" style="height: 160px" max-width="150px" elevation="0" disable>
          <v-icon size="80"  color="white" style="text-shadow: 3px 3px black">mdi-animation-play</v-icon>
          <v-card class="pa-3 rounded-xl"-text class="mt-2 pa-0 px-1 text-caption text-center white--text">
            Events Highlights
          </v-card>
        </v-card>
      </v-col> -->
      </v-row>
    </v-container>
  </v-img>
</template>

<script>
export default {
  name: "Home",
  computed: {
    backgroundImage() {
      return this.$store.state.conference.cover_image;
    }
  }
};
</script>

<style lang="scss" scoped>
.v-card :focus {
  color: transparent !important;
}
</style>
